import type { MSubCategoryHijaSubcategoryV2 } from "@/Models/MSubCategories/MPLPCategory";
import type { SubCategories } from "@/Models/MSubCategories/SubCategories";

export const MapperButtons = (
  data: MSubCategoryHijaSubcategoryV2[],
  category: string
) => {
  if (data && data.length > 0) {
    const datosFilter =
      data
        ?.find((w) => w.Id === category)
        ?.SubCategories?.filter(
          (s) => Array.isArray(s.Products) && s.Products.length > 0
        )
        ?.flatMap((f) => f.Name) ?? [];

    const mappedDataBrand: SubCategories[] = datosFilter.map((id) => ({
      names: id,
    }));

    return mappedDataBrand;
  }
  return [];
};
